package link.erpango.quip.utils

import io.ktor.util.decodeBase64Bytes
import kotlinx.serialization.json.Json
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.entities.JwtPayload


fun exportData(vehicles: List<DVehicle>): String {
    return Json.encodeToString(vehicles)
}

fun importData(jsonString: String): List<DVehicle> {
    return Json.decodeFromString(jsonString)
}


fun decodeJwt(token: String): JwtPayload? {
    val parts = token.split(".")
    if (parts.size != 3) return null

    val payload = parts[1]
    val decodedBytes = payload.decodeBase64Bytes()
    val decodedString = decodedBytes.toString()

    return try {
        Json.decodeFromString<JwtPayload>(decodedString)
    } catch (e: Exception) {
        null
    }
}